import React from 'react';
// import eventBanner from 'assets/img/generic/13.jpg';
import { Card, Row, Col } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import Calendar from 'components/common/Calendar';
// import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
// import paths from 'routes/paths';

const TemplateDetailHeader = ({ template }) => {
  return (
    <Card className="p-0 mb-3">
      {/* {!!eventBanner && (
        <img className="card-img-top" src={eventBanner} alt="" />
      )} */}
      <Card.Body className="overflow-hidden">
        <Row className="flex-center">
          <Col>
            <Flex alignItems={'center'}>
              <Calendar
                month={moment(template?.startDate).format('MMM')}
                day={moment(template?.startDate).format('DD')}
                // {...eventInfo.eventDate}
              />
              <div className="fs-10 ms-2 flex-1">
                <h5 className="fs-9 text-capitalize">
                  {template?.jobType}-{template?.shiftTitle}
                </h5>
                <p className="mb-0 text-capitalize">
                  Posted by{' '}
                  {/* <Link className="ms-1" to={paths?.nursd_facility}> */}
                  {template?.manager?.firstName} {template?.manager?.lastName}
                  {/* </Link> */}
                </p>
              </div>
            </Flex>
          </Col>
          <Col md="auto" className="mt-4 mt-md-0">
            <h5 className="fs-9 text-capitalize mt-2">
              {template?.jobTemplateName}
            </h5>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

TemplateDetailHeader.propTypes = {
  template: PropTypes.any
};

export default TemplateDetailHeader;
